/** 首页 Plus 输入框 → 对话工作流 的一次性交接 */
export const WORKFLOW_PROMPT_HANDOFF_KEY = 'cw_prompt_handoff'

/**
 * @param {{
 *   prompt?: string,
 *   contentPlain?: string,
 *   contentHtml?: string,
 *   modelId?: string,
 *   style?: object|null,
 *   uploads?: Array<{ kind?: string, url?: string, name?: string }>,
 *   referencedUploads?: Array<{ kind?: string, url?: string, name?: string }>,
 *   autoSend?: boolean
 * }} payload
 */
export function saveWorkflowPromptHandoff(payload) {
  try {
    const refs =
      Array.isArray(payload && payload.referencedUploads) && payload.referencedUploads.length
        ? payload.referencedUploads
        : Array.isArray(payload && payload.uploads)
          ? payload.uploads
          : []
    sessionStorage.setItem(
      WORKFLOW_PROMPT_HANDOFF_KEY,
      JSON.stringify({
        prompt: payload && payload.prompt != null ? String(payload.prompt) : '',
        contentPlain:
          payload && payload.contentPlain != null
            ? String(payload.contentPlain)
            : payload && payload.prompt != null
              ? String(payload.prompt)
              : '',
        contentHtml: payload && payload.contentHtml != null ? String(payload.contentHtml) : '',
        modelId: payload && payload.modelId != null ? String(payload.modelId) : '',
        style: payload && payload.style ? payload.style : null,
        uploads: refs,
        referencedUploads: refs,
        autoSend: !!(payload && payload.autoSend)
      })
    )
    return true
  } catch (e) {
    return false
  }
}

/** @returns {object|null} */
export function consumeWorkflowPromptHandoff() {
  try {
    const raw = sessionStorage.getItem(WORKFLOW_PROMPT_HANDOFF_KEY)
    sessionStorage.removeItem(WORKFLOW_PROMPT_HANDOFF_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (!data || typeof data !== 'object') return null
    return data
  } catch (e) {
    try {
      sessionStorage.removeItem(WORKFLOW_PROMPT_HANDOFF_KEY)
    } catch (err) {
      /* ignore */
    }
    return null
  }
}
